import { _ as __rest } from './tslib.es6-21effb23.js';
import { c as classNames } from './index-29eed6c4.js';
import React__default, { useLayoutEffect, useEffect, useRef, useState, useMemo } from 'react';
import { C as CheckIcon } from './CheckIcon-dae9b9aa.js';
import './countries-66cada71.js';

// https://usehooks-ts.com/react-hook/use-isomorphic-layout-effect
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

// https:usehooks-ts.com/react-hook/use-timeout
function useTimeout(callback, delay) {
    var savedCallback = useRef(callback);
    // Remember the latest callback if it changes.
    useIsomorphicLayoutEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the timeout.
    useEffect(function () {
        // Don't schedule if no delay is specified.
        // Note: 0 is a valid value for delay.
        if (!delay && delay !== 0) {
            return;
        }
        var id = setTimeout(function () { return savedCallback.current(); }, delay);
        return function () { return clearTimeout(id); };
    }, [delay]);
}

var styles = {"container":"ProgressRing_container_0cf30118","circle":"ProgressRing_circle_0cf30118","checkIcon":"ProgressRing_checkIcon_0cf30118","label":"ProgressRing_label_0cf30118","visible":"ProgressRing_visible_0cf30118"};

var ProgressRing = function (_a) {
    var className = _a.className, radius = _a.radius, stroke = _a.stroke, type = _a.type, label = _a.label, datatestId = _a["data-testid"], _b = _a.color, color = _b === void 0 ? "action" : _b, props = __rest(_a, ["className", "radius", "stroke", "type", "label", "data-testid", "color"]);
    var normalizedRadius = radius - stroke * 2;
    var circumference = normalizedRadius * 2 * Math.PI;
    var _c = useState(0), progress = _c[0], setProgress = _c[1];
    var _d = useState(false), done = _d[0], setDone = _d[1];
    var progressRingStyle = useMemo(function () { return ({
        "--progress-color": "var(--color-ui-".concat(color, ")"),
        "--background-progress-color": "var(--color-ui-".concat(color, "-20)"),
        "--progress-label-color": "var(--color-ui-".concat(color, "-dark)"),
        "--progress-label-font-size": radius < 30 ? "0.6rem" : "0.8rem",
    }); }, [color, radius]);
    useTimeout(function () {
        setProgress(100);
    }, type === "time" ? 1 : null);
    useTimeout(function () {
        setDone(true);
    }, type === "time"
        ? props.animationProps.time
        : null);
    useEffect(function () {
        if (type == "progress") {
            setProgress(props.animationProps.progress);
        }
        if (type == "progress" && progress === 100) {
            setDone(true);
        }
    }, [progress, props, type]);
    var strokeDashoffset = circumference - (progress / 100) * circumference;
    return (React__default.createElement("div", { className: classNames(className, styles.container), style: { width: radius * 2, height: radius * 2 }, "data-testid": datatestId },
        React__default.createElement("svg", { height: radius * 2, width: radius * 2 },
            React__default.createElement("circle", { className: styles.circle, shapeRendering: "geometricPrecision", stroke: progressRingStyle["--background-progress-color"], fill: "transparent", strokeWidth: stroke, style: { strokeDashoffset: strokeDashoffset }, r: normalizedRadius, cx: radius, cy: radius }),
            React__default.createElement("circle", { className: styles.circle, shapeRendering: "geometricPrecision", stroke: progressRingStyle["--progress-color"], fill: "transparent", strokeWidth: stroke, strokeDasharray: circumference + " " + circumference, strokeLinecap: "round", style: {
                    strokeDashoffset: strokeDashoffset,
                    transition: type === "time"
                        ? "stroke-dashoffset ".concat(props.animationProps.time, "ms linear")
                        : "stroke-dashoffset 100ms linear",
                }, r: normalizedRadius, cx: radius, cy: radius })),
        React__default.createElement("div", { className: styles.checkIcon }, label ? (React__default.createElement("div", { className: styles.label, "data-testid": "progress-ring-label", style: {
                color: progressRingStyle["--progress-label-color"],
                fontSize: progressRingStyle["--progress-label-font-size"],
            } }, label)) : (React__default.createElement(CheckIcon, { "data-testid": "progress-ring-check-icon", fillColor: progressRingStyle["--progress-color"], className: classNames(done && styles.visible) })))));
};

export { ProgressRing as P, useTimeout as a, useIsomorphicLayoutEffect as u };
